import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-deleted",
  templateUrl: "./deleted.component.html",
  styleUrls: ["./deleted.component.scss", "../template/template.component.scss"]
})
export class DeletedComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
